import { AppThunkAction } from 'redux/store';
import { showErrorAlert } from 'redux/utils';
import {
  getDiscountRequestNotifications,
  getUnreadDiscountRequestNotifications,
} from 'services/notifications';
import { NotificationType } from 'interfaces';
import {
  setNotificationList,
  setUnreadNotificationCounts,
} from './notifications';

export const getDiscountRequestNotificationsThunk =
  (types: NotificationType[]): AppThunkAction =>
  async (dispatch) => {
    try {
      const notifications = await getDiscountRequestNotifications({
        size: 1000,
        direction: 'DESC',
        sort: 'NOTIFICATION_TIME',
        typeFilter: types,
      });

      dispatch(setNotificationList(notifications));
    } catch (e) {
      showErrorAlert(dispatch, e, 'Could not get notifications');
    }
  };

export const getDiscountRequestUnreadNotificationCountThunk =
  (): AppThunkAction => async (dispatch) => {
    try {
      const unreadNotifications = await getUnreadDiscountRequestNotifications();

      dispatch(setUnreadNotificationCounts(unreadNotifications.length));
    } catch (e) {
      showErrorAlert(dispatch, e, 'Could not get unread notification count');
    }
  };
